import { render } from "./ServeAction.vue?vue&type=template&id=511371fc"
import script from "./ServeAction.vue?vue&type=script&lang=js"
export * from "./ServeAction.vue?vue&type=script&lang=js"

import "./ServeAction.vue?vue&type=style&index=0&id=511371fc&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__